module.exports = __webpack_public_path__ + "img/card-Marinevich-family.11dccfe7.jpg";